import { createStoreWithProducer } from '@xstate/store';
import { produce } from 'immer';

export type WindowSize = 'medium' | 'sidePanel';

export type FloatingWindowStoreContext = {
  /**
   * Request to toggle the floating window open/closed.
   * null = no request pending
   * true = request to open
   * false = request to close
   * Consumed and cleared by EhrRecordingWidget.
   */
  openRequested: boolean | null;
  /**
   * Requested size when opening the floating window.
   * Used with openRequested=true to specify the desired size.
   */
  requestedSize?: WindowSize;
};

const defaultContext: FloatingWindowStoreContext = {
  openRequested: null,
};

export const floatingWindowStore = createStoreWithProducer(
  produce,
  defaultContext,
  {
    toggleFloatingWindow: (context, event: { open: boolean }) => {
      context.openRequested = event.open;
    },
    openAsSidePanel: (context) => {
      context.openRequested = true;
      context.requestedSize = 'sidePanel';
    },
    clearRequest: (context) => {
      context.openRequested = null;
      context.requestedSize = undefined;
    },
  },
);
